import React, { useState } from "react";
import { FiEdit, FiSave, FiX } from "react-icons/fi";
import {
  useUpdatePersonalInfoMutation,
  useGetUserByIdQuery,
} from "store/user/userApi";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PersonalDetails = ({ user }) => {
  const { _id, name, email, createdAt } = user;
  const authUser = useSelector((state) => state.auth.user);

  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(name);
  const [editedEmail, setEditedEmail] = useState(email);

  const [updatePersonalInfo, { isLoading }] = useUpdatePersonalInfoMutation();
  const { refetch } = useGetUserByIdQuery(authUser._id, {
    skip: !authUser?._id,
  });

  const formattedDate = new Date(createdAt).toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const handleSaveUser = async () => {
    try {
      await updatePersonalInfo({
        userId: _id,
        data: { name: editedName, email: editedEmail },
      }).unwrap();
      setIsEditing(false);
      await refetch();
    } catch (err) {
      console.error("Erreur lors de la mise à jour :", err);
    }
  };

  const handleCancelUser = () => {
    setEditedName(name);
    setEditedEmail(email);
    setIsEditing(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
        <h5 style={{ color: "#0f84ff" }}>{t("profile.personalInfo")}</h5>
        {!isEditing ? (
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setIsEditing(true)}
            title={t("profile.editTitle")}>
            <FiEdit />
          </button>
        ) : (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-success"
              onClick={handleSaveUser}
              disabled={isLoading}>
              <FiSave />
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={handleCancelUser}
              disabled={isLoading}>
              <FiX />
            </button>
          </div>
        )}
      </div>

      <div className="row mb-4">
        <div className="col-sm-6">
          <small className="text-muted">{t("profile.fullName")}</small>
          {isEditing ? (
            <input
              className="form-control"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
            />
          ) : (
            <p className="text-dark">{name}</p>
          )}
        </div>
        <div className="col-sm-6">
          <small className="text-muted">{t("profile.email")}</small>
          {isEditing ? (
            <input
              className="form-control"
              value={editedEmail}
              onChange={(e) => setEditedEmail(e.target.value)}
            />
          ) : (
            <p className="text-dark">{email}</p>
          )}
        </div>
        <div className="col-sm-6">
          <small className="text-muted">{t("profile.createdAt")}</small>
          <p className="text-dark">{formattedDate}</p>
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
